// extracted by mini-css-extract-plugin
export var closeButton = "_q5-2";
export var closeButtonIcon = "_q5-3";
export var lightboxContent = "_q5-1";
export var lightboxOverlay = "_q5-0";